<template>
	<div>
		<el-dialog title="详情" :visible.sync="show" width="30%">
			<activeDet :row="row"></activeDet>
			<el-divider></el-divider>
			
			<el-input  type="textArea" placeholder="请填写回复" :rows="30" v-model="feedback"></el-input>
			<span  slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button type="primary" @click="yes('已同意')">确 定</el-button>
			</span> 
		</el-dialog>
		<el-form :inline="true" :model="form" class="demo-form-inline">
			<el-form-item label="姓名">
				<el-input v-model="form.name" placeholder="姓名" clearable=""></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getAll()">查询</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="type" label="类型"></el-table-column>
			
			<el-table-column prop="name" label="姓名"></el-table-column>
			<el-table-column prop="roomNumber" label="房间号"></el-table-column>
			<el-table-column prop="phone" label="联系电话"></el-table-column>
	
			<el-table-column prop="time" label="时间">
				<template slot-scope="{row}">{{setTime(row.time)}}</template>
			</el-table-column>
				<el-table-column prop="category" label="申请类别"></el-table-column>
			<el-table-column prop="reson" label="内容"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="getRow(row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum">
		</el-pagination>
	</div>
</template>

<script>
import activeDet from "./activeDet.vue";
export default {
  components: {
    activeDet,
  },
  data() {
    return {
      roleId: sessionStorage.roleId,
      user: "", //派单选择的工人
      users: [],
      show: false,
      data: [],
      feedback: null,
      row: {},
      form: {
        result: "未处理",
        status: "", //
        name: "",
        currentPage: 1,
        pageSize: 10,
      },
      totalNum: 0,
    };
  },
  methods: {
    getId(val) {
      console.log(val);
    },
    yes(val) {
      console.log(this.user);
      if (this.feedback == null) {
        this.$message.warning("请填写回复内容");
        return;
      }
      this.show = false;
      this.$http
        .post(`/api/bdComplaint/approvalComplaint`, {
          feedback: this.feedback,
          status: val,
          id: this.row.id,
          result: "已处理",
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.message);
            this.getAll();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    ok(type) {
      this.show = false;
      this.$http
        .post(`/api/bdServiceApply/ApprovalServiceApply`, {
          id: this.row.id,
          result: type ? "已同意" : "已拒绝",
          processId: this.row.processId,
          agree: type == 1,
          reason: this.reason,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.message);
            this.getAll();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    handleCurrentChange(val) {
      this.form.currentPage = val;
      this.getAll();
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getAll();
    },
    getRow(row) {
      this.feedback = "";
      console.log(row);
      // row.showPathList=JSON.parse(row.showPathList)
      this.row = row;
      this.show = true;
    },
    getAll() {
      this.$http
        .post(`/api/bdComplaint/queryComplaint`, this.form)
        .then((r) => {
          if (r.data.data != null) {
            this.data = r.data.data.items;

            this.totalNum = r.data.data.totalNum;
          } else {
            this.data = null;
            this.totalNum = 0;
          }
        });
    },
    getUsers() {
      this.$http.get(`/api/bdRepairApply/getDispatch`).then((r) => {
        this.users = r.data.data;
      });
    },
  },
  mounted() {
    this.getAll();
    //this.getUsers()
  },
};
</script>

<style>
</style>
